<template>
    <div class="s4s-page">
      <div class="s4s-select-car">
        <div class="list" v-for="(car,index) in carList" :key="index">
          <div class="bd">
            <div class="bd-fl">
              <span class="car-no">{{ car.proviceCarno }}</span>
              <div class="s4s-list-btn" :data-car="car" @click="editCar(car)" >编辑</div>
              <div class="s4s-list-btn" :data-car="car" @click="showDelCar(car)" >删除</div>
            </div>
          </div>
        </div>
  </div>
   <button type="primary" class="s4s-btn" style="margin-top:50px;"
    @click="gotoCar" hover-class="defaultTap" :style="{backgroundImage:advertisingShow.backgroundImage}"> 添加爱车 </button>
    <!-- 删除 start -->
     <Confirm
    :show-dialog="showDelete"
    :ok-text="'确定'"
    :cancel-text="'取消'"
    :title="'确认删除爱车'"
    :content="'确认删除爱车'+ deleteId + '?'"
    v-on:confirm="deleteCar"
    v-on:cancel="showDelete = false"
  />
    <!-- 删除 end -->
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import Confirm from '@/components/Confirm.vue';
import advertisingShow from './../utils/advertising';

export default {
  name: 'carList',
  components: {
    Confirm,
  },
  data() {
    return {
      showDelete: false,
      deleteId: '',
      advertisingShow: advertisingShow(),
    };
  },
  computed: {
    ...mapGetters([
      'carList',
    ]),
    
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '选择爱车'
      });
    }

    this.$store.dispatch('getCar', { refresh: true }).then((res) => {
      console.log(res);
   
    });
  },
  methods: {
    gotoCar() {
      this.$router.push({
        name: 'addcar',
      });
    },
    editCar(carinfo) {
      this.$router.push({
        name: 'addcar',
        query: carinfo,
      });
    },
    showDelCar(item) {
      this.showDelete = true;
      this.deleteId = item.proviceCarno;
    },
    deleteCar() {
      const param = {
        carno: this.deleteId,
      };
      this.$request('v3/violation/car/del', param).then((xhr, res) => {
        if (res.code === 0) {
          this.showDelete = false;
          this.deleteId = '';
          this.$showToast({
            icon: 'none',
            title: '删除成功',
          });
          this.$store.dispatch('getCar', { refresh: true }).then((ress) => {
          });
        } else {
          this.$showToast({
            icon: 'none',
            title: res.msg,
          });
        }
      });
    },

  },
};
</script>


<style>
.s4s-page {
  padding: 10px 15px;
  background: #f8f8f8;
  font-size: 14px;
}
.list {
  padding: 10px 0;
  border-bottom: 1px solid #EFEFEF;
}
.list:last-child {
  border-bottom: none;
}
.bd {
  display: flex;
  align-items: center;
}

.bd-fl {
  display: flex;
  align-items: center;
  flex: 1;
}

.head-icon {
  width: 60px;
  height: 60px;
}

.car-info {
  padding: 10px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.car-info-bd {
  display: flex;
  align-items: center;
  padding-bottom: 5px;
}

.car-info-edit {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.car-no {
  font-size: 14px;
  color: #2E2E2E;
  flex: 1;
}

.brand {
  font-size: 13px;
  color: #99a9bf;
  line-height: 150%;
}

.s4s-option-out {
  width: 22px;
  height: 22px;
}

.s4s-set-default {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-image: linear-gradient(-90deg, #00a2f6 3%, #00bef6 75%);
  color: #fff;
}

.s4s-car-add {
  background: #fff;
  box-shadow: 0 1px 3px 0 #d3dce6;
  border-radius: .02rem;
  padding: 20px 0;
  text-align: center;
}
.s4s-car-add image {
  width: 50px;
  height: 50px;
  margin: 0 auto;
}
.s4s-car-add view {
  color: #999;
  font-size: 14px;
  padding-top: 15px;
}
.s4s-select-car {
  background: #fff;
  box-shadow: 0 2px 4px 0 #EFEFEF;
  border-radius: 2px;
  padding:0 15px;

}


.s4s-list-btn {
  line-height: 19px;
  font-size: 12px;
  color: #3A82FF;
  border: .5px solid #3A82FF;
  border-radius :2px;
  padding: 4px 11px;
  display: inline-block;
}

.s4s-list-btn:last-child {
  color: #ffaf30;
  border: .5px solid #ffaf30;
  margin-left: 8px;
}
.s4s-btn{
  display: block;
  width: 100%;
  margin: 50px 0 12px;
}
</style>

